/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { clipzyPostClipzyStore } from "../../funcs/clipzyPostClipzyStore.js";
import { PostClipzyStoreRequest$zodSchema } from "../../models/postclipzystoreop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostClipzyStoreRequest$zodSchema,
};

export const tool$clipzyPostClipzyStore: ToolDefinition<typeof args> = {
  name: "clipzy--post-clipzy-store",
  description: `步骤1：上传加密数据

这是所有流程的第一步。您的客户端应用需要先在本地准备好 **加密后的数据**，然后调用此接口进行上传。成功后，您会得到一个用于后续操作的唯一ID。

> [!NOTE]
> 您发送给此接口的应该是**密文**，而不是原始文本。请参考文档首页的JavaScript示例来了解如何在客户端进行加密。`,
  scopes: ["read", "write"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await clipzyPostClipzyStore(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
